import React from 'react';
import {connect} from 'react-redux';
import strings from '../../utils/strings';

import AudioPlayer from '../../components/AudioPlayer';
import previewVideoNo from './assets/no_skrivhastighet_video.mov';
import previewVideoNn from './assets/nn_skrivhastighet_video.mov';

import previewVideoSe from './assets/se_skrivhastighet_video.mov';
import previewVideoDeLower from './assets/de_skrivhastighet_video.mp4';
import lowerIntroAudio from '../../assets/sounds/child/de/4 1 Skrivehastighet Intro.mp3';
import upperIntroAudio from '../../assets/sounds/child/de/upper_Skrivehastighet Intro.mp3';
import previewVideoDeUpper from './assets/upper_Skrvi_de.mp4';
import instructionVideo from './assets/writing-instruction.mp4';
import {VARIATION} from '../../constants';

const deVideoPreview = {
	'2': previewVideoDeLower,
	'3': previewVideoDeLower,
	'4': previewVideoDeLower,
	'5': previewVideoDeUpper,
	'6': previewVideoDeUpper,
	'7': previewVideoDeUpper,
	'8': previewVideoDeUpper,
};

const deIntroAudio = {
	'2': lowerIntroAudio,
	'3': lowerIntroAudio,
	'4': lowerIntroAudio,
	'5': upperIntroAudio,
	'6': upperIntroAudio,
	'7': upperIntroAudio,
	'8': upperIntroAudio,
};

class Intro extends React.Component {
	constructor(props) {
		super(props);

		const variation = VARIATION;
		const language = strings.getLanguage();
		const grade = Number(this.props.candidateGrade);

		const relevantVideoPreview =
			deVideoPreview[this.props.candidateGrade.toString()];
		const relevantIntroAudio =
			deIntroAudio[this.props.candidateGrade.toString()];

		this.videoPc = instructionVideo;

		this.data = require(`../../assets/testdata/${variation}/${language}/skrivehastighet-data.json`);
		this.taskIsOver =
			language === 'de'
				? require(`../../assets/sounds/${variation}/${language}/SCR062.mp3`)
				: null;

		this.text = this.data[grade].value;

		const previewVideoObj = {
			no: previewVideoNo,
			nn: previewVideoNn,
			se: previewVideoSe,
			de: relevantVideoPreview,
		};

		const assets = {
			data: require(`../../assets/testdata/${variation}/${language}/skrivehastighet-data.json`),
			audio: relevantIntroAudio,
			video: previewVideoObj[language], // TODO: Use different ones for all langs
		};

		this.currentLang = language;
		this.audio = assets.audio;
		this.video = assets.video;
		this.audioRef = React.createRef();
		this.previewVideoEl = null;
		this.videoRefView = React.createRef();
		this.introAudioRef = React.createRef();
	

		this.handleManualPlayAudio = this.handleManualPlayAudio.bind(this);
		this.handleAudioTimeUpdate = this.handleAudioTimeUpdate.bind(this);
		this.scrollToPreviewAndPlay = this.scrollToPreviewAndPlay.bind(this);


		// Reordered flow:
		// INTRO (audio+text+preview) -> INSTRUCTION (writing-instruction.mp4) -> START
		this.state = {
			removeTestSentence: false,
			step: 'INTRO', // 'INTRO' | 'INSTRUCTION'
			canGoToInstruction: false, // becomes true when intro audio completes (or errors)
			canStart: false, // becomes true when instruction video ends
			audioStarted: false,
  			audioNeedsClick: false,
 			hasAutoScrolledToPreview: false,
		};
	}
componentDidMount() {
  this.autoplayWatchdog = setTimeout(() => {
    if (!this.state.audioStarted) {
      this.setState({audioNeedsClick: true});
    }
  }, 2000); // slightly conservative; adjust if you want
}

componentWillUnmount() {
  if (this.autoplayWatchdog) clearTimeout(this.autoplayWatchdog);
}


// Called when user clicks "Play audio"
handleManualPlayAudio() {
  var el = this.introAudioRef.current;
  if (!el) return;

  var p = el.play(); // user gesture -> usually allowed
  if (p && p.catch) {
    p.catch(() => {
      this.setState({audioNeedsClick: true});
    });
  }

  // if it starts, onStart will also clear audioNeedsClick
}

scrollToPreviewAndPlay() {
  if (this.videoRefView && this.videoRefView.current) {
    this.videoRefView.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }

  // wait a bit so the element is actually in view before playing
  setTimeout(() => {
    if (this.previewVideoEl && !this.state.removeTestSentence) {
      var p = this.previewVideoEl.play();
      if (p && p.catch) p.catch(function () {}); // ignore autoplay-block errors
    }
  }, 350);
}


handleAudioTimeUpdate(e) {
  if (this.state.hasAutoScrolledToPreview || this.state.removeTestSentence) return;

  var a = e && e.target ? e.target : null;
  if (!a) return;

  var dur = a.duration;
  var triggerAt = 31; // seconds (your original intent)

  if (dur && isFinite(dur)) {
    // if audio shorter than 31s, trigger near the end instead
    triggerAt = Math.min(31, Math.max(0, dur - 2));
  }

  if (a.currentTime >= triggerAt) {
    this.setState({hasAutoScrolledToPreview: true});
    this.scrollToPreviewAndPlay();
  }
}


	renderIntroStep(onNextStep) {
		let videoRef; // preview video ref (same pattern as your original)

		return (
			<div>
				<p className="text-left">
					<AudioPlayer
  autoplay
  audioRef={this.introAudioRef}
  onTimeUpdate={this.handleAudioTimeUpdate}
  onErrorPlay={() => {
    console.log('Something went wrong');
    this.setState({audioNeedsClick: true, canGoToInstruction: true});
  }}
  inline
  onStart={() => {
    if (this.autoplayWatchdog) clearTimeout(this.autoplayWatchdog);
    this.setState({audioStarted: true, audioNeedsClick: false});
  }}

  onPause={() => {
  if (!this.state.removeTestSentence && this.previewVideoEl) {
    this.previewVideoEl.play();
  }
}}

  onComplete={() => {
    this.setState({canGoToInstruction: true});

    if (!this.state.removeTestSentence) {
      this.scrollToPreviewAndPlay();
      setTimeout(() => {
        this.setState({removeTestSentence: true});
      }, 10000);
    }
  }}
  src={this.audio}
/>


					{strings.skrivehastighetIntro}
				</p>
{this.state.audioNeedsClick && (
  <button
    className="lit-btn bg-primary"
    onClick={this.handleManualPlayAudio}
  >
    {this.currentLang === 'de' ? 'Audio starten' : 'Play audio'}
  </button>
)}
				<br />
				<p className="text-left">{strings.skrivehastighetIntro1}</p>
				<br />
				<p className="text-left">{strings.skrivehastighetIntro2}</p>
				<br />
				<p className="text-left">
					{strings.formatString(strings.skrivehastighetIntro3, this.text)}
				</p>

				{!this.state.removeTestSentence && (
					<div className="lit-preview" ref={this.videoRefView}>
						<p className="lit-preview__label">{strings.taskLooksLikeThis}</p>
						<video
							className="lit-preview__video"
							loop
							playsInline
							onClick={() => {
  							if (this.previewVideoEl) this.previewVideoEl.play();
							}}
							muted
							ref={(ref) => {this.previewVideoEl = ref;}}
							src={this.video}
						/>
					</div>
				)}

				<p>{strings.skrivehastighetHint}</p>
				<br />
				<p>{strings.skrivehastighetIntroFinal}</p>

				{/* Instead of Start here, go to the instruction video AFTER intro is done */}
				{this.state.canGoToInstruction && (
					<button
						className="lit-btn bg-primary"
						onClick={() => {
							this.setState({
								step: 'INSTRUCTION',
								canStart: false,
							});
							setTimeout(() => window.scrollTo(0, 0));
						}}
					>
						{'Weiter'}
					</button>
				)}
			</div>
		);
	}

	renderInstructionStep(onNextStep) {
		let instructionRef;

		return (
			<div className="lit-test lit-word-chain">
				<div className="lit-wrapper tutorial">
					<div className="lit-preview" ref={this.videoRefView}>
						<p className="lit-preview__label">{'Anweisungen'}</p>

						<video
							className="lit-preview__video"
							onEnded={() => {
								this.setState({canStart: true});
							}}
							playsInline
							controls
							ref={(ref) => {
								instructionRef = ref;
							}}
							onClick={() => {
								if (instructionRef) {
									instructionRef.play();
								}
							}}
							src={this.videoPc}
						/>
					</div>

					{this.state.canStart && (
						<button
							className="lit-btn bg-primary"
							onClick={() => {
								onNextStep(); // proceed to Test substep
							}}
						>
							{strings.start}
						</button>
					)}
				</div>
			</div>
		);
	}

	render() {
		const {onNextStep} = this.props;

		return (
			<div className="">
				{this.state.step === 'INTRO'
					? this.renderIntroStep(onNextStep)
					: this.renderInstructionStep(onNextStep)}
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const {candidateGrade} = state;
	return {
		candidateGrade,
	};
};

export default connect(mapStateToProps)(Intro);
